module.exports = __webpack_public_path__ + "img/hef_teclis_0.7ab86650.png";